import styled from 'styled-components/macro';
import { colorAccentAlert100, colorAccentAlert700Base, colorCoreGray100 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { INDENT } from '@yme/tokens/sizes';
export const DefaultModalContentStyled = styled.div `
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
`;
export const DefaultModalContentTextStyled = styled.div `
  padding-bottom: ${INDENT.sm};
`;
export const IconWrapper = styled.div `
  padding: 14px;
  background-color: ${colorAccentAlert700Base};
  border-radius: ${CORNER_RADIUS.circle};
  border: ${INDENT.xxs} solid ${colorAccentAlert100};
  svg path {
    stroke: ${colorCoreGray100};
  }
`;
